import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenConversations = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 30,
	viewBox: "0 0 33 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6566 26.9492C11.1385 26.9492 11.4759 26.7082 12.0421 26.1781L16.4036 22.2022L24.5361 22.2143C28.1266 22.2263 30.0541 20.2263 30.0541 16.6962V7.46731C30.0541 3.93718 28.1266 1.94922 24.5361 1.94922H9.0181C5.43976 1.94922 3.50002 3.9251 3.50002 7.46731V16.6962C3.50002 20.2384 5.43976 22.2143 9.0181 22.2022H9.58434V25.7083C9.58434 26.4553 9.98191 26.9492 10.6566 26.9492Z",
			fill: "#E4EAEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.6575 12.0563C24.6575 11.5934 24.473 11.1495 24.1446 10.8222C23.8162 10.4949 23.3707 10.311 22.9063 10.311C22.4418 10.311 21.9964 10.4949 21.668 10.8222C21.3396 11.1495 21.1551 11.5934 21.1551 12.0563C21.1551 12.5191 21.3396 12.963 21.668 13.2903C21.9964 13.6176 22.4418 13.8015 22.9063 13.8015C23.3707 13.8015 23.8162 13.6176 24.1446 13.2903C24.473 12.963 24.6575 12.5191 24.6575 12.0563ZM18.5283 12.0563C18.5283 11.5934 18.3437 11.1495 18.0153 10.8222C17.6869 10.4949 17.2415 10.311 16.777 10.311C16.3126 10.311 15.8672 10.4949 15.5387 10.8222C15.2103 11.1495 15.0258 11.5934 15.0258 12.0563C15.0258 12.5191 15.2103 12.963 15.5387 13.2903C15.8672 13.6176 16.3126 13.8015 16.777 13.8015C17.2415 13.8015 17.6869 13.6176 18.0153 13.2903C18.3437 12.963 18.5283 12.5191 18.5283 12.0563ZM12.399 12.0563C12.399 11.5934 12.2145 11.1495 11.8861 10.8222C11.5576 10.4949 11.1122 10.311 10.6478 10.311C10.1833 10.311 9.73789 10.4949 9.40947 10.8222C9.08105 11.1495 8.89655 11.5934 8.89655 12.0563C8.89655 12.5191 9.08105 12.963 9.40947 13.2903C9.73789 13.6176 10.1833 13.8015 10.6478 13.8015C11.1122 13.8015 11.5576 13.6176 11.8861 13.2903C12.2145 12.963 12.399 12.5191 12.399 12.0563Z",
			fill: "#416774"
		})
	]
});
const ForwardRef = forwardRef(SvgOpenConversations);
export { ForwardRef as ReactComponent };
